// Persistence for the feature slice. Same storage strategy as the rest of the
// widget (tenant-scoped localStorage key, written on every state change), but
// the restored value passes through `normalizeFormsState` first — this feature
// deliberately drops parts of its own state on restore (pending suggestions, an
// in-flight turn), so a plain restore would be wrong.

import { useEffect, useReducer } from 'react';
import { log } from '../../Utilities/logging';
import { CfAction, CfState, formsReducer, normalizeFormsState } from './formsReducer';

const readStored = (storageKey: string): unknown => {
    try {
        if (typeof window === 'undefined') return undefined;
        const raw = window.localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : undefined;
    } catch (e) {
        log('edulla-chat', (e as Error).message, 'visitor', { sessionId: '' });
        return undefined;
    }
};

export const useFormsPersistence = (storageKey: string): [CfState, React.Dispatch<CfAction>] => {
    const [state, dispatch] = useReducer(
        formsReducer,
        storageKey,
        (key) => normalizeFormsState(readStored(key))
    );

    useEffect(() => {
        try {
            if (typeof window === 'undefined') return;
            window.localStorage.setItem(storageKey, JSON.stringify(state));
        } catch (e) {
            log('edulla-chat', (e as Error).message, 'visitor', { sessionId: '' });
        }
    }, [storageKey, state]);

    return [state, dispatch];
};
